import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { DistributionTypeReferenceModel } from "../../models/reference-model/reference-general-model/distribution-type-reference.model";

@Injectable({
    providedIn: 'root'
})
export class DistributionTypeReferenceService extends ApiServiceBase {
    private readonly REFERENCE_PATH = '/system/DistributionTypeReferences';

    constructor(
        httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getDistributionTypeReferences(): Observable<DistributionTypeReferenceModel[]> {
        return this.httpGet<DistributionTypeReferenceModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}